/**
 * Created by KhalidManasra on 14/03/2019.
 */
function LMSModalService() {

}

var lmsModalService = new LMSModalService();

(function (angular) {

    "use strict";

    angular.module('harriMainApp').controller("LMSComplianceModalController", LMSComplianceModalController);

    LMSComplianceModalController.$inject = ['$scope', 'modalData', 'onSave', '$filter', 'deviceChecker', '$state', '$rootScope'];

    function LMSComplianceModalController($scope, modalData, onSave, $filter, deviceChecker, $state, $rootScope) {
        var self = this;
        var registrationId = modalData.registrationId;
        var languageCode = modalData.languageCode;
        var courseProviderCode = modalData.courseProviderCode;
        var courseUrl;
        self.courseName = modalData.courseName;
        self.isLoading = true;
        self.timeTracker = 0;

        // we need to store it once
        var isWarningConfirmed = !!HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
            key: 'isWarningConfirmed'
        });

        self.isWarningConfirmed = isWarningConfirmed;
        self.isIOS = deviceChecker.iOS();
        self.isIOSChrome = !!deviceChecker.isIOSChrome();
        self.isSafari= deviceChecker.isSafari() && !deviceChecker.isIOSChrome();

        if(self.isSafari && !isWarningConfirmed){
            // show the warning only once
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'isWarningConfirmed',
                value: 'confirmed',
            });
        }

        lmsModalService.closeModal = function () {
            self.hideModal();
            $scope.$digest();
        };

        var init = function() {
            if($rootScope.$previousState && $rootScope.$previousState.indexOf('dashboard-member') > -1) {
                $state.go('.lms-scrom',{registration_id: registrationId});
            }
        };

        ComplianceTrainingAPI.getRedirectURL(registrationId, languageCode).then(function (regData) {
            if (courseProviderCode === 'UPSKILL') {
                window.open(regData.redirect_url, '_blank');
                self.hideModal();
            } else {
                self.courseUrl = regData.redirect_url;
            }
            self.isLoading = false;
            $scope.$digest();
        }, function () {
            hAlert($filter("translate")("Something went wrong"), $filter("translate")("Error loading Course details"));
            self.hideModal();
        });

        this.hideModal = function () {
            if ($state.current.name === 'dashboard-member.lms-scrom') {
                $state.go('^');
            }
            $scope.$hide();
            onSave();
        };

        init();

        this.canLoadTheCourse = function(){
            return (!self.isSafari || self.isSafari && isWarningConfirmed) && !self.isIOSChrome ;
        };
    }
})(angular);
